import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { optionPrice, todayIst } from '../utils/pricing';

/** Date-based prices for one option: each row's price applies from its date (IST) until the next row. */
const PriceScheduleEditor = ({ option, onChange }) => {
  const schedule = option.priceSchedule || [];
  const update = (index, patch) => onChange(schedule.map((tier, i) => (i === index ? { ...tier, ...patch } : tier)));
  const add = () => onChange([...schedule, { fromDate: '', price: option.price || 0 }]);
  const remove = (index) => onChange(schedule.filter((_, i) => i !== index));
  const today = todayIst();

  return (
    <div className="px-3 pb-3 pt-2 border-t bg-white space-y-2">
      <p className="text-xs text-gray-600">
        Base price {option.price || 0} applies until the first date below; each row applies from its date (IST).
        Price today: <span className="font-medium text-gray-900">{optionPrice(option)}</span>
      </p>
      {schedule.map((tier, index) => (
        <div key={index} className="flex items-center gap-2">
          <span className="text-xs text-gray-500 w-10">From</span>
          <Input
            type="date"
            value={tier.fromDate || ''}
            onChange={(e) => update(index, { fromDate: e.target.value })}
            className="text-sm w-40"
          />
          <Input
            type="number"
            min="0"
            step="0.01"
            value={tier.price ?? ''}
            onChange={(e) => update(index, { price: e.target.value === '' ? '' : parseFloat(e.target.value) })}
            placeholder="Price"
            className="text-sm w-28"
          />
          {tier.fromDate && tier.fromDate <= today && <span className="text-xs text-green-700">started</span>}
          <Button type="button" variant="ghost" size="sm" onClick={() => remove(index)} aria-label="Remove price">
            <Trash2 className="w-4 h-4 text-red-500" />
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={add} className="text-xs">
        <Plus className="w-3 h-3 mr-1" />
        Add date-based price
      </Button>
    </div>
  );
};

export default PriceScheduleEditor;
